import { combineReducers } from "redux";
import footer from './cms.reducer';

const reducer = combineReducers({
    footer
});

export default reducer;